// import meter1 from "../assets/img/meter1.svg";
// import meter2 from "../assets/img/meter2.svg";
// import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
// import arrow1 from "../assets/img/arrow1.svg";
// import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";
import { FaReact } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { SiTailwindcss } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { SiExpress } from "react-icons/si";
import { SiMongodb } from "react-icons/si";
import { FaGitAlt } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { TbBrandVscode } from "react-icons/tb";
import { SiPostman } from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";
import { SiNestjs } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { LiaDocker } from "react-icons/lia";
import { SiSwagger } from "react-icons/si";
import { SiOpenai } from "react-icons/si";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>
                Constantly evolving, always mastering new skills.<br></br> Here
                are some of my skills on which I have been working on for the
                past 2 years.
              </p>
              <Carousel
                // responsive={responsive}
                // infinite={true}
                // autoplay={1}
                // autoPlaySpeed={2000} // Enable autoplay
                className="owl-carousel owl-theme skill-slider"
                additionalTransfrom={0}
                arrows
                autoPlay
                autoPlaySpeed={2000}
                centerMode={false}
                infinite
                minimumTouchDrag={80}
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 3000,
                      min: 1024,
                    },
                    items: 3,
                    partialVisibilityGutter: 40,
                  },
                  mobile: {
                    breakpoint: {
                      max: 464,
                      min: 0,
                    },
                    items: 1,
                    partialVisibilityGutter: 30,
                  },
                  tablet: {
                    breakpoint: {
                      max: 1024,
                      min: 464,
                    },
                    items: 2,
                    partialVisibilityGutter: 30,
                  },
                }}
                shouldResetAutoplay
                slidesToSlide={1}
                swipeable
              >
                <div className="item">
                  <SiOpenai size={98} color="#3b82f6" />

                  <h5>OpenAI</h5>
                </div>
                <div className="item">
                  <FaReact size={98} color="#22d3ee" />
                  <h5>React Js</h5>
                </div>
                <div className="item">
                  <TbBrandNextjs size={98} color="#d4d4d8" />
                  <h5>Next Js</h5>
                </div>
                <div className="item">
                  <SiNestjs size={98} color="#e11d48" />
                  <h5>Nest Js</h5>
                </div>
                <div className="item">
                  <IoLogoJavascript size={98} color="#fef08a" />

                  <h5>JavaScript</h5>
                </div>

                <div className="item">
                  <FaNodeJs size={98} color="#4ade80" />

                  <h5>Node Js</h5>
                </div>
                <div className="item">
                  <SiExpress size={98} color="#d4d4d4" />

                  <h5>Express Js</h5>
                </div>
                <div className="item">
                  <SiMongodb size={98} color="#22c55e" />

                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <GrMysql size={98} color="#22d3ee" />

                  <h5>Mysql</h5>
                </div>
                <div className="item">
                  <SiTailwindcss size={98} color="#38bdf8" />

                  <h5>Tailwind CSS</h5>
                </div>

                <div className="item">
                  <FaGitAlt size={98} color="#ea580c" />

                  <h5>Git</h5>
                </div>
                <div className="item">
                  <FaGithub size={98} color="#e4e4e7" />

                  <h5>GitHub</h5>
                </div>
                <div className="item">
                  <TbBrandVscode size={98} color="#0ea5e9" />

                  <h5>VS Code</h5>
                </div>
                <div className="item">
                  <SiPostman size={98} color="#f97316" />

                  <h5>Postman</h5>
                </div>
                <div className="item">
                  <LiaDocker size={98} color="#3b82f6" />

                  <h5>Docker</h5>
                </div>
                <div className="item">
                  <SiSwagger size={98} color="#bef264" />

                  <h5>Swagger</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="img" />
    </section>
  );
};
